import type { ReactNode } from "react";

interface EmptyStateProps {
  icon?: string;
  title: string;
  description?: string;
  action?: ReactNode;
  children?: ReactNode;
}

export default function EmptyState({ icon = "ri-inbox-line", title, description, action, children }: EmptyStateProps) {
  return (
    <div className="flex flex-col items-center justify-center rounded-lg border border-dashed border-background-300 bg-background-100 px-6 py-16 text-center">
      <span className="flex h-16 w-16 items-center justify-center rounded-full bg-background-200 text-foreground-400">
        <i className={`${icon} text-3xl`} />
      </span>
      <h3 className="mt-4 font-heading text-base font-bold text-foreground-900">{title}</h3>
      {description && <p className="mt-2 max-w-md text-sm text-foreground-500">{description}</p>}
      {(action || children) && (
        <div className="mt-5 flex flex-wrap justify-center gap-3">
          {action}
          {children}
        </div>
      )}
    </div>
  );
}